import { useState, useEffect } from 'react';
import IPDService from '../services/ipdService';

const ipdService = new IPDService();

export const useGetPatientDetails = (patientId) => {
    const [patientDetails, setPatientDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPatientDetails = async () => {
            if (!patientId) return;

            setLoading(true);
            setError(null);
            try {
                const data = await ipdService.getPatientById(patientId);
                setPatientDetails(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPatientDetails();
    }, [patientId]);

    return {
        patientDetails,
        loading,
        error,
        refetch: () => {
            setLoading(true);
            setError(null);
            return ipdService.getPatientById(patientId)
                .then(data => {
                    setPatientDetails(data);
                    return data;
                })
                .catch(err => {
                    setError(err.message);
                    throw err;
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
}; 